import axios from 'axios';
import { BACKEND_URL } from './config';

function normalizeTrendingRow(row) {
  const name = typeof row?.name === 'string' ? row.name.trim() : '';
  if (!name) return null;
  const item = { name };
  if (typeof row.meta === 'string' && row.meta.trim()) item.meta = row.meta.trim();
  if (typeof row.delta === 'string' && row.delta.trim()) item.delta = row.delta.trim();
  return item;
}

/**
 * Public guest trending queries for the search dropdown and What's on shortcuts.
 * Empty list is the honest fallback (hide the UI). Do not invent watching %.
 */
export async function getTrendingSearches() {
  try {
    const { data } = await axios.get(`${BACKEND_URL}/api/discovery/trending-searches`, {
      timeout: 10000,
    });
    if (!Array.isArray(data?.items)) return [];
    return data.items.map(normalizeTrendingRow).filter(Boolean);
  } catch {
    return [];
  }
}
